import React from "react";
import "./TableOfContentsOnToolbar.scss";

import { useDispatch, useSelector } from "react-redux";
import { CustomSwitch } from "src/app/components/CustomSwitch/CustomSwitch";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import {
  setReportGridElements,
  setReportHiddenGridElements,
  setReportLayout,
} from "src/redux";
import Tooltip from "src/app/components/Tooltip/Tooltip";

const TableOfContentsOnToolbar = () => {
  const { gridElements, hiddenGridElements, layout, campaigns } = useSelector(
    (state) => state.reportReducer,
  );

  const dispatch = useDispatch();

  const isInGridElements = gridElements.some(
    (item) => item.gridBoxType === "table-of-contents",
  );
  const isInHiddenGridElements = hiddenGridElements.some(
    (item) => item.gridBoxType === "table-of-contents",
  );
  const isTableOfContentsDisplayed =
    isInGridElements && !isInHiddenGridElements;

  const toggle = (e) => {
    const { checked } = e.target;

    const filteredGridElements = gridElements.filter(
      (item) => item.gridBoxType !== "table-of-contents",
    );
    const hiddenGridElementsToAdd = gridElements.filter(
      (item) => item.gridBoxType === "table-of-contents",
    );
    const gridElementsToAdd = hiddenGridElements.filter(
      (item) => item.gridBoxType === "table-of-contents",
    );
    const filteredHiddenGridElements = hiddenGridElements.filter(
      (item) => item.gridBoxType !== "table-of-contents",
    );

    if (checked) {
      dispatch(setReportGridElements([...gridElements, ...gridElementsToAdd]));
      dispatch(setReportHiddenGridElements(filteredHiddenGridElements));
    } else {
      dispatch(setReportGridElements(filteredGridElements));
      dispatch(
        setReportHiddenGridElements([
          ...hiddenGridElements,
          ...hiddenGridElementsToAdd,
        ]),
      );
    }

    removeTableOfContentsFromLayout();
    if (checked) {
      const newElements = [
        ...gridElementsToAdd,
        ...hiddenGridElementsToAdd,
      ].sort((a, b) => a.part - b.part);
      addTableOfContentsToLayout(newElements);
    }
  };

  const addTableOfContentsToLayout = (gridElementsToAdd) => {
    let newLayout = [...layout];

    const difference = 17 * gridElementsToAdd.length;

    newLayout = newLayout.map((item) => ({
      ...item,
      y: item.y >= 17 ? item.y + difference : item.y,
    }));

    gridElementsToAdd.forEach((el, idx) => {
      newLayout.push({
        i: el.label,
        x: 0,
        y: 17 * (idx + 1),
        w: 12,
        h: 16,
        static: true,
      });
    });

    const generator = document.querySelector(".template-generator");
    generator.scroll({
      top: 1200,
      left: 0,
      behavior: "smooth",
    });
    dispatch(setReportLayout(newLayout));
  };

  const removeTableOfContentsFromLayout = () => {
    const filteredLayout = layout.filter(
      (item) => item.i.slice(0, 17) !== "table-of-contents",
    );
    dispatch(setReportLayout(filteredLayout));
  };

  if (Object.keys(campaigns).length === 0) return null;

  return (
    <div className="table-of-contents-on-toolbar">
      <div className="table-of-contents-on-toolbar__header">
        <IDHFormattedMessage
          id="ws_display_table_of_contents"
          defaultMessage="Display Table of Contents"
        />
        <Tooltip
          alignRight
          content={
            <IDHFormattedMessage
              id="ws_tooltip_table_of_contents_toolbar"
              defaultMessage="Here you can enable or disable the table of contents. It will appear after the first page of the report."
            />
          }
        />
      </div>

      <CustomSwitch onChange={toggle} checked={isTableOfContentsDisplayed} />
    </div>
  );
};

export default TableOfContentsOnToolbar;
